import { createSlice } from "@reduxjs/toolkit";

const successSlice = createSlice({
    name: 'success',
    initialState: {
        success: {
            title: "",
            message: "",
            isSuccess: "",
            orderID: ""
        }
    },
    reducers: {
        setSuccess: (state, action) => {
            state.success.title = action.payload.title;
            state.success.message = action.payload.message;
            state.success.isSuccess = action.payload.isSuccess;
            state.success.orderID = action.payload.orderID;
        }
    }
});

export const successActions = successSlice.actions;
export default successSlice;